import { may, type CanHolder } from "../../lib/access";

/**
 * F-009 Stammdatenverwaltung affordance (ADR-API-09: the server re-checks
 * every admin route): `masterdata.edit` of the rights matrix ([F-027]), from
 * `/me.can`. Decides only whether the nav link and the screen are shown.
 */
export function canManageMasterData(user: CanHolder | null | undefined): boolean {
  return may(user, "masterdata.edit");
}
